import { type ReactElement, createContext } from 'react';

export const AnnotationsIconImagesContext = createContext<
  Map<ReactElement, HTMLImageElement>
>(new Map());
